import { authApi } from '../../utils/api';

export const adminTekliflerPage = () => {
    const user = authApi.getCurrentUser();

    if (!user || user.rol !== 'admin') {
        return `
            <section class="page-content">
                <div class="container">
                    <div class="alert alert-danger">
                        <p>Bu sayfaya erişim yetkiniz yok.</p>
                        <a href="/" class="btn-primary">Ana Sayfaya Dön</a>
                    </div>
                </div>
            </section>
        `;
    }

    return `
        <section class="page-content admin-page">
            <div class="container">
                <div class="page-header">
                    <h1 class="page-title">Teklif Talepleri</h1>
                    <div class="header-actions">
                        <a href="/admin" class="btn-outline">← Admin Paneli</a>
                    </div>
                </div>

                <!-- Filtreler -->
                <div class="filters">
                    <select id="filterTeklifDurum" class="form-control">
                        <option value="">Tüm Durumlar</option>
                        <option value="yeni">Yeni</option>
                        <option value="islemde">İşlemde</option>
                        <option value="tamamlandi">Tamamlandı</option>
                        <option value="iptal">İptal</option>
                    </select>
                </div>

                <!-- Teklif Detay Modal -->
                <div id="teklifModal" class="modal" style="display: none;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2>Teklif Detay</h2>
                            <button class="modal-close" id="closeTeklifModal">&times;</button>
                        </div>
                        <div id="teklifDetail" class="modal-body"></div>
                        <form id="teklifUpdateForm" class="modal-form">
                            <input type="hidden" id="teklifId">
                            <div class="form-group">
                                <label for="teklifDurum">Durum</label>
                                <select id="teklifDurum" class="form-control">
                                    <option value="yeni">Yeni</option>
                                    <option value="islemde">İşlemde</option>
                                    <option value="tamamlandi">Tamamlandı</option>
                                    <option value="iptal">İptal</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="teklifAdminNotu">Admin Notu</label>
                                <textarea id="teklifAdminNotu" class="form-control" rows="3" placeholder="Not ekleyin..."></textarea>
                            </div>
                            <div class="modal-actions">
                                <button type="button" class="btn-outline" id="cancelTeklifBtn">İptal</button>
                                <button type="submit" class="btn-primary">Güncelle</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div id="tekliflerList" class="data-table-container">
                    <div class="loading">Yükleniyor...</div>
                </div>
            </div>
        </section>
    `;
};
